export default "__VITE_ASSET__CjRHK$dy__"